import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.71 40.9699C73.71 40.9699 60.15 34.0799 56.1 29.3499C51.6 24.0899 51.8 1.44995 51.8 1.44995H39.37C39.37 1.44995 39.68 24.1999 35.07 29.3499C30.18 34.8099 17.46 40.7699 17.46 40.7699C23.65 55.3499 36.05 59.0699 45.58 59.0699C55.11 59.0699 67.51 55.5499 73.71 40.9699Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 57.8699C85.68 45.8599 82.03 42.6199 77.36 40.2699C75.06 39.1099 60.53 31.3899 60.53 31.3899L45.94 47.2399L30.64 31.3899C30.64 31.3899 16.2 39.0599 13.8 40.2699C9.13 42.6199 5.57 46.2499 3.92 57.8699C2.44 68.9299 2 71.6899 2 71.6899H89.15C89.16 71.6799 88.54 68.1599 87.24 57.8699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.7998 33.98L45.9498 54.78L65.5998 34.64"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5814"
          y1="42.6171"
          x2="45.5814"
          y2="8.58445"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
